// useUpdateSupportStatus (issue #419) — PATCH /chats/support/:chatId/status.

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { SupportInboxScope, updateSupportStatus } from './api';
import { chatKeys } from './keys';

import type { Chat, SupportStatus } from 'src/models/chat';

interface Args {
  chatId: number;
  status: SupportStatus;
}

export function useUpdateSupportStatus(scope: SupportInboxScope = 'legacy') {
  const queryClient = useQueryClient();
  return useMutation<Chat, unknown, Args>(
    ({ chatId, status }) => updateSupportStatus(chatId, { status }, scope),
    {
      onSuccess: (_chat, { chatId }) => {
        queryClient.invalidateQueries(chatKeys.supportInboxRoot());
        queryClient.invalidateQueries(chatKeys.chat(chatId));
        queryClient.invalidateQueries(chatKeys.chatMessages(chatId));
      },
    }
  );
}
